import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import quiz from './quiz/sagas';
import reward from './reward/sagas';

export default function* rootSaga() {
  yield all([auth, quiz, reward]);
}
